import { useEffect, useState } from 'react';

export const useWindowSize = (): number[] => {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);

  useEffect(() => {
    function updateSize() {
      setSize((prev) => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        if (prev[0] === w && prev[1] === h) return prev;
        return [w, h];
      });
    }

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
};
